// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FuKbV","newExpiryDate":"styles_newExpiryDate__1bDdN","footer":"styles_footer__2KW6M"};